import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaErrorViewComponent } from '@global-front-components/ui/error-view';

@Component({
	selector: 'app-error',
	standalone: true,
	imports: [CommonModule, CaErrorViewComponent],
	templateUrl: './error.view.html',
	styleUrls: ['./error.view.scss'],
	host: {
		'data-view-id': 'error-view'
	}
})
export class ErrorView {}
